import styled from "@emotion/styled";
import React from "react";
import { neutralDark40, visBlueLight10 } from "../../../constants/colors";
import { Token } from "../../token";
const StyledMultiValueToken = styled(Token)`
    margin-right: 4px;
    margin-top: 6px;
`;

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const MultiValue = props => {
  return /*#__PURE__*/React.createElement(StyledMultiValueToken, {
    className: props.className,
    isDisabled: props.isDisabled,
    onCloseSelected: props.removeProps.onClick,
    onMouseDown: props.removeProps.onMouseDown,
    color: {
      backgroundColor: visBlueLight10,
      textColor: neutralDark40
    }
  }, props.children);
};
//# sourceMappingURL=MultiValue.js.map